import { useQuery } from "@tanstack/react-query";
import { useAppData } from "../context/Contexts";

const useCustomProductQuery = () => {
    const { currentAppData, setCurrentAppData } = useAppData();

    const {
        status,
        data,
        error,
        isFetching,
        refetch
    } = useQuery({
        queryKey: ['productCustom'],
        refetchOnWindowFocus: false,
        enabled: false,
        queryFn: ({ }) => fetchCustomProduct(),
    }
    )

    let Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || 'US';
    const defaultQuery = (opts) => {
        let q = `
      query @inContext(country: ${Shopify.country}) {
        
  product(id: "gid://shopify/Product/9609839509796") {
    id
    title
    handle
    availableForSale
    createdAt
    productType
    tags
    collections(first: 5) {
      edges {
        node {
          id
          title
        }
      }
    }
    images(first: 100) {
      edges {
        node {
          id
          url
          altText
        }
      }
    }
    options {
        id
        name
        optionValues {
            name
            id
        }
    }
    variants(first: 100) {
      edges {
        node {
          id
          sku
          availableForSale
          title
          currentlyNotInStock
          selectedOptions {
            name
            value
          }
          image {
            id
            url
          }
          priceV2 {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          
        }
      }
    }
  }
}`;

        return q;
    }

    const buildQuery = (opts) => {

        let q = defaultQuery({ ...opts })

        return q;
    }

    const fetchCustomProduct = async (pageParam = null) => {
        //console.log(key);
        // console.log('pageParam: ');
        // console.log(pageParam);

        const myHeaders = new Headers();
        myHeaders.append("X-Shopify-Storefront-Access-Token", "2ec833273cdc3f57cd90d9b80c9c5a80");
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
            query: buildQuery({}),
            variables: { "after": "" }
        })
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow'
        };

        const response = await fetch("https://seatcoversolutions-7977.myshopify.com/api/2025-07/graphql.json", requestOptions)
            .catch(error => console.log('error', error));

        const data = await response.json();

        setCurrentAppData(prevState => {
            return { ...prevState, product: data.data.product }
        });

        return data.data.product
    }

    return {custom_status: status,
        custom_data: data,
        custom_error: error,
        custom_isFetching: isFetching,
        custom_refetch: refetch};
};

export default useCustomProductQuery;